/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { ConversationTurn } from "./ConversationTurn";
import {
  ConversationTurnFromJSON,
  ConversationTurnFromJSONTyped,
  ConversationTurnToJSON,
  ConversationTurnToJSONTyped,
} from "./ConversationTurn";
import type { FreightClaimLineItem } from "./FreightClaimLineItem";
import {
  FreightClaimLineItemFromJSON,
  FreightClaimLineItemFromJSONTyped,
  FreightClaimLineItemToJSON,
  FreightClaimLineItemToJSONTyped,
} from "./FreightClaimLineItem";
import type { FreightClaimPaymentSource } from "./FreightClaimPaymentSource";
import {
  FreightClaimPaymentSourceFromJSON,
  FreightClaimPaymentSourceFromJSONTyped,
  FreightClaimPaymentSourceToJSON,
  FreightClaimPaymentSourceToJSONTyped,
} from "./FreightClaimPaymentSource";
import type { FreightClaimState } from "./FreightClaimState";
import {
  FreightClaimStateFromJSON,
  FreightClaimStateFromJSONTyped,
  FreightClaimStateToJSON,
  FreightClaimStateToJSONTyped,
} from "./FreightClaimState";

/**
 *
 * @export
 * @interface FreightClaim
 */
export interface FreightClaim {
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  freightClaimId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaim
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  companyId?: string;
  /**
   *
   * @type {FreightClaimState}
   * @memberof FreightClaim
   */
  freightClaimState?: FreightClaimState;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  proNumber?: string;
  /**
   *
   * @type {Array<FreightClaimLineItem>}
   * @memberof FreightClaim
   */
  freightClaimLineItems?: Array<FreightClaimLineItem>;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  claimDescription?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  claimInternalNotes?: string;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaim
   */
  claimCurrency?: CurrencyCode;
  /**
   *
   * @type {Array<string>}
   * @memberof FreightClaim
   */
  originalInvoiceFiles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof FreightClaim
   */
  photoFiles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof FreightClaim
   */
  otherDocumentFiles?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  assignee?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  carrierFrontConversationId?: string;
  /**
   *
   * @type {ConversationTurn}
   * @memberof FreightClaim
   */
  carrierConversationTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaim
   */
  carrierConversationTurnTime?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  customerFrontConversationId?: string;
  /**
   *
   * @type {ConversationTurn}
   * @memberof FreightClaim
   */
  customerConversationTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaim
   */
  customerConversationTurnTime?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  insuranceFrontConversationId?: string;
  /**
   *
   * @type {ConversationTurn}
   * @memberof FreightClaim
   */
  insuranceConversationTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaim
   */
  insuranceConversationTurnTime?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaim
   */
  snoozedUntil?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  snoozeReason?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  carrierClaimNumber?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaim
   */
  lastCarrierPingAt?: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof FreightClaim
   */
  claimPaymentAmount?: number;
  /**
   *
   * @type {FreightClaimPaymentSource}
   * @memberof FreightClaim
   */
  claimPaymentSource?: FreightClaimPaymentSource;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  claimPaymentReason?: string;
  /**
   *
   * @type {number}
   * @memberof FreightClaim
   */
  claimPayoutAmount?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaim
   */
  claimPaymentCurrency?: CurrencyCode;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaim
   */
  claimPayoutCurrency?: CurrencyCode;
  /**
   *
   * @type {number}
   * @memberof FreightClaim
   */
  claimInsuranceAmount?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaim
   */
  claimInsuranceCurrency?: CurrencyCode;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  claimXeroInvoiceId?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaim
   */
  claimXeroBillId?: string;
  /**
   *
   * @type {number}
   * @memberof FreightClaim
   */
  claimXeroSequence?: number;
  /**
   *
   * @type {boolean}
   * @memberof FreightClaim
   */
  claimXeroStale?: boolean;
}

/**
 * Check if a given object implements the FreightClaim interface.
 */
export function instanceOfFreightClaim(value: object): value is FreightClaim {
  return true;
}

export function FreightClaimFromJSON(json: any): FreightClaim {
  return FreightClaimFromJSONTyped(json, false);
}

export function FreightClaimFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FreightClaim {
  if (json == null) {
    return json;
  }
  return {
    freightClaimId:
      json["freightClaimId"] == null ? undefined : json["freightClaimId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    freightClaimState:
      json["freightClaimState"] == null
        ? undefined
        : FreightClaimStateFromJSON(json["freightClaimState"]),
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    freightClaimLineItems:
      json["freightClaimLineItems"] == null
        ? undefined
        : (json["freightClaimLineItems"] as Array<any>).map(
            FreightClaimLineItemFromJSON,
          ),
    claimDescription:
      json["claimDescription"] == null ? undefined : json["claimDescription"],
    claimInternalNotes:
      json["claimInternalNotes"] == null
        ? undefined
        : json["claimInternalNotes"],
    claimCurrency:
      json["claimCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimCurrency"]),
    originalInvoiceFiles:
      json["originalInvoiceFiles"] == null
        ? undefined
        : json["originalInvoiceFiles"],
    photoFiles: json["photoFiles"] == null ? undefined : json["photoFiles"],
    otherDocumentFiles:
      json["otherDocumentFiles"] == null
        ? undefined
        : json["otherDocumentFiles"],
    assignee: json["assignee"] == null ? undefined : json["assignee"],
    carrierFrontConversationId:
      json["carrierFrontConversationId"] == null
        ? undefined
        : json["carrierFrontConversationId"],
    carrierConversationTurn:
      json["carrierConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["carrierConversationTurn"]),
    carrierConversationTurnTime:
      json["carrierConversationTurnTime"] == null
        ? undefined
        : json["carrierConversationTurnTime"],
    customerFrontConversationId:
      json["customerFrontConversationId"] == null
        ? undefined
        : json["customerFrontConversationId"],
    customerConversationTurn:
      json["customerConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["customerConversationTurn"]),
    customerConversationTurnTime:
      json["customerConversationTurnTime"] == null
        ? undefined
        : json["customerConversationTurnTime"],
    insuranceFrontConversationId:
      json["insuranceFrontConversationId"] == null
        ? undefined
        : json["insuranceFrontConversationId"],
    insuranceConversationTurn:
      json["insuranceConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["insuranceConversationTurn"]),
    insuranceConversationTurnTime:
      json["insuranceConversationTurnTime"] == null
        ? undefined
        : json["insuranceConversationTurnTime"],
    snoozedUntil:
      json["snoozedUntil"] == null ? undefined : json["snoozedUntil"],
    snoozeReason:
      json["snoozeReason"] == null ? undefined : json["snoozeReason"],
    carrierClaimNumber:
      json["carrierClaimNumber"] == null
        ? undefined
        : json["carrierClaimNumber"],
    lastCarrierPingAt:
      json["lastCarrierPingAt"] == null ? undefined : json["lastCarrierPingAt"],
    claimPaymentAmount:
      json["claimPaymentAmount"] == null
        ? undefined
        : json["claimPaymentAmount"],
    claimPaymentSource:
      json["claimPaymentSource"] == null
        ? undefined
        : FreightClaimPaymentSourceFromJSON(json["claimPaymentSource"]),
    claimPaymentReason:
      json["claimPaymentReason"] == null
        ? undefined
        : json["claimPaymentReason"],
    claimPayoutAmount:
      json["claimPayoutAmount"] == null ? undefined : json["claimPayoutAmount"],
    claimPaymentCurrency:
      json["claimPaymentCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimPaymentCurrency"]),
    claimPayoutCurrency:
      json["claimPayoutCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimPayoutCurrency"]),
    claimInsuranceAmount:
      json["claimInsuranceAmount"] == null
        ? undefined
        : json["claimInsuranceAmount"],
    claimInsuranceCurrency:
      json["claimInsuranceCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimInsuranceCurrency"]),
    claimXeroInvoiceId:
      json["claimXeroInvoiceId"] == null
        ? undefined
        : json["claimXeroInvoiceId"],
    claimXeroBillId:
      json["claimXeroBillId"] == null ? undefined : json["claimXeroBillId"],
    claimXeroSequence:
      json["claimXeroSequence"] == null ? undefined : json["claimXeroSequence"],
    claimXeroStale:
      json["claimXeroStale"] == null ? undefined : json["claimXeroStale"],
  };
}

export function FreightClaimToJSON(json: any): FreightClaim {
  return FreightClaimToJSONTyped(json, false);
}

export function FreightClaimToJSONTyped(
  value?: FreightClaim | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    freightClaimId: value["freightClaimId"],
    createdAt: value["createdAt"],
    shipmentId: value["shipmentId"],
    companyId: value["companyId"],
    freightClaimState: FreightClaimStateToJSON(value["freightClaimState"]),
    carrierIdentifier: value["carrierIdentifier"],
    proNumber: value["proNumber"],
    freightClaimLineItems:
      value["freightClaimLineItems"] == null
        ? undefined
        : (value["freightClaimLineItems"] as Array<any>).map(
            FreightClaimLineItemToJSON,
          ),
    claimDescription: value["claimDescription"],
    claimInternalNotes: value["claimInternalNotes"],
    claimCurrency: CurrencyCodeToJSON(value["claimCurrency"]),
    originalInvoiceFiles: value["originalInvoiceFiles"],
    photoFiles: value["photoFiles"],
    otherDocumentFiles: value["otherDocumentFiles"],
    assignee: value["assignee"],
    carrierFrontConversationId: value["carrierFrontConversationId"],
    carrierConversationTurn: ConversationTurnToJSON(
      value["carrierConversationTurn"],
    ),
    carrierConversationTurnTime: value["carrierConversationTurnTime"],
    customerFrontConversationId: value["customerFrontConversationId"],
    customerConversationTurn: ConversationTurnToJSON(
      value["customerConversationTurn"],
    ),
    customerConversationTurnTime: value["customerConversationTurnTime"],
    insuranceFrontConversationId: value["insuranceFrontConversationId"],
    insuranceConversationTurn: ConversationTurnToJSON(
      value["insuranceConversationTurn"],
    ),
    insuranceConversationTurnTime: value["insuranceConversationTurnTime"],
    snoozedUntil: value["snoozedUntil"],
    snoozeReason: value["snoozeReason"],
    carrierClaimNumber: value["carrierClaimNumber"],
    lastCarrierPingAt: value["lastCarrierPingAt"],
    claimPaymentAmount: value["claimPaymentAmount"],
    claimPaymentSource: FreightClaimPaymentSourceToJSON(
      value["claimPaymentSource"],
    ),
    claimPaymentReason: value["claimPaymentReason"],
    claimPayoutAmount: value["claimPayoutAmount"],
    claimPaymentCurrency: CurrencyCodeToJSON(value["claimPaymentCurrency"]),
    claimPayoutCurrency: CurrencyCodeToJSON(value["claimPayoutCurrency"]),
    claimInsuranceAmount: value["claimInsuranceAmount"],
    claimInsuranceCurrency: CurrencyCodeToJSON(value["claimInsuranceCurrency"]),
    claimXeroInvoiceId: value["claimXeroInvoiceId"],
    claimXeroBillId: value["claimXeroBillId"],
    claimXeroSequence: value["claimXeroSequence"],
    claimXeroStale: value["claimXeroStale"],
  };
}
